/**
 * StickyActionBar — vaste balk onder in het scherm, boven de bottom-nav.
 *
 * 1 of 2 knoppen in `flex gap-2`. Safe-area-aware via `.wb-sticky-bar`
 * (bottom = nav-hoogte + env(safe-area-inset-bottom)). De pagina die hem
 * gebruikt zet `pb-[140px]` op de content zodat niets erachter valt.
 */

import clsx from 'clsx';

export interface StickyActionBarProps {
  children: React.ReactNode;
  className?: string;
}

export function StickyActionBar({ children, className }: StickyActionBarProps) {
  return (
    <div className={clsx('wb-sticky-bar bg-wb-vlak border-t-wb border-wb-rand', className)}>
      <div className="max-w-container mx-auto px-3 py-2.5 flex gap-2">{children}</div>
    </div>
  );
}
